var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.611 17.1889C13.3963 16.9741 13.3963 16.6259 13.611 16.4111L17.611 12.4111C17.8258 12.1963 18.1741 12.1963 18.3889 12.4111C18.6036 12.6259 18.6036 12.9741 18.3889 13.1889L14.3889 17.1889C14.1741 17.4037 13.8258 17.4037 13.611 17.1889Z",
    fill: "#383634"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.389 17.1889C18.6037 16.9741 18.6037 16.6259 18.389 16.4111L14.389 12.4111C14.1742 12.1963 13.8259 12.1963 13.6111 12.4111C13.3964 12.6259 13.3964 12.9741 13.6111 13.1889L17.6111 17.1889C17.8259 17.4037 18.1742 17.4037 18.389 17.1889Z",
    fill: "#383634"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 17.45C16.3037 17.45 16.55 17.6963 16.55 18V22.45H22C22.3037 22.45 22.55 22.6963 22.55 23C22.55 23.3038 22.3037 23.55 22 23.55H16C15.6962 23.55 15.45 23.3038 15.45 23V18C15.45 17.6963 15.6962 17.45 16 17.45Z",
    fill: "#383634"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0802 0.452422C11.2715 0.315827 11.5283 0.315827 11.7196 0.452422L21.9196 7.73814C22.0641 7.84138 22.1499 8.00807 22.1499 8.18569V17.9C22.1499 18.2037 21.9037 18.45 21.5999 18.45C21.2961 18.45 21.0499 18.2037 21.0499 17.9V8.46873L11.3999 1.57587L1.7499 8.46873V20.75H5.0999C5.40366 20.75 5.6499 20.9962 5.6499 21.3C5.6499 21.6037 5.40366 21.85 5.0999 21.85H1.1999C0.896146 21.85 0.649902 21.6037 0.649902 21.3V8.18569C0.649902 8.00807 0.735683 7.84138 0.880221 7.73814L11.0802 0.452422Z",
    fill: "#383634"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54995 17.45V22.45H14C14.3037 22.45 14.55 22.6963 14.55 23C14.55 23.3038 14.3037 23.55 14 23.55H7.99995C7.69619 23.55 7.44995 23.3038 7.44995 23V17.45H8.54995Z",
    fill: "#383634"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49995 8.45001C6.80371 8.45001 7.04995 8.69626 7.04995 9.00001V10.7H8.94995V9.00001C8.94995 8.69626 9.19619 8.45001 9.49995 8.45001C9.80371 8.45001 10.05 8.69626 10.05 9.00001V10.7H10.9C11.2589 10.7 11.55 10.991 11.55 11.35V14.1466C11.55 16.1466 9.97799 17.8 7.99995 17.8C6.02191 17.8 4.44995 16.1466 4.44995 14.1466V11.35C4.44995 10.991 4.74097 10.7 5.09995 10.7H5.94995V9.00001C5.94995 8.69626 6.1962 8.45001 6.49995 8.45001ZM5.54995 11.8V14.1466C5.54995 15.5745 6.66428 16.7 7.99995 16.7C9.33562 16.7 10.45 15.5745 10.45 14.1466V11.8H5.54995Z",
    fill: "#383634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModificationIcon);
export default __webpack_public_path__ + "static/media/modification_icon.77de820319e16b37e7dc228f4024c24a.svg";
export { ForwardRef as ReactComponent };